export default "__VITE_ASSET__BW1WjRVK__"